import React from "react";
import{connect} from "react-redux";
import { bindActionCreators } from "redux";
import {menuOverlay} from "../../actions/HeaderActions"
const Overlay = () =>{
    return(
        <div className="bg-black opacity-25 overlay-container d-none d-lg-block position-fixed"></div>
    )
}

const mapStateToProps = state =>({
    showMobileOverlay:state.CommonReducer.showMobileOverlay
})
const mapDispatchToProps = dispatch =>bindActionCreators({
        menuOverlayfunc: menuOverlay,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Overlay);